<template>
    <div class="tabs">
        <div v-for="(item, index) in navigation"
            :key="index"
            :class="[
                { 'tab--active': isActive(item) },
                `tab tab--${item.class}`
            ]"
            :style="{ color: item.color }"
            @click="toggleTab(item)"
        >
            <i :class="`icon-${item.icon}`" />
            <span>{{ $t(item.text) }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'tab-menu',
    props: {
        navigation: {
            type: Array,
            default: () => ([]),
        },
        activeTab: {
            type: String,
            default: '',
        },
    },
    methods: {
        isActive(item) {
            return item.name === this.activeTab;
        },
        toggleTab(item) {
            this.$emit('toggleTab', item);
        },
    },
};
</script>

<style lang="scss" scoped>
.tabs {
    display: flex;
    width: 100%;
    justify-content: space-between;
    position: relative;
    border-top: $white-color solid 0.1rem;

    @include min-width(md) {
        border-top: none;
        justify-content: flex-start;
    }
}

.tab {
    display: flex;
    text-align: center;
    flex-wrap: wrap;
    font-size: 1.4rem;
    line-height: 4rem;
    padding: 0.5rem;

    @include min-width(xl) {
        font-size: 1.8rem;
        width: auto;
        padding: 0 2rem 2.5rem;
        margin-right: 1.6rem;
    }

    @include max-width(sm) {
        margin-right: 0;
    }

    &:hover {
        opacity: 0.8;
        cursor: pointer;
    }

    &:hover,
    &--active {
        border-bottom: 0.3rem solid;
        padding-bottom: 0.2rem;

        @include min-width(xl) {
            padding-bottom: 2.5rem;
        }
    }

    &--transactions {
        i {
            left: -0.2rem;
            @include min-width(xl) {
                left: -1.6rem;
            }
        }
    }

    span {
        font-size: 1.3rem;
        white-space: nowrap;
        width: 100%;
        font-weight: 600;

        @include max-width(sm) {
            font-size: 1.15rem;
        }

        @include min-width(xl) {
            width: initial;
            text-align: left;
            font-size: 1.8rem;
        }
    }

    i {
        position: relative;
        font-size: 4rem;
        border-radius: 100%;
        width: 100%;

        @include max-width(sm) {
            font-size: 3rem;
        }

        @include min-width(xl) {
            width: initial;
            left: -1.6rem;
            top: 0.5rem;
            font-size: 3rem;
        }
    }
}
</style>